<template>
  <div class="light">
    <div class="header">
      <div class="title">窗帘设备列表</div>
      <div class="fast-btn">
        <dtit-button :is-cover="groupInfo['isCovers']" :state="groupInfo['state']" class="addgroup" :text="groupInfo['text']" :type="groupInfo['type']" :is-cancel="groupInfo['isCancel']" :icon-url="groupInfo['iconUrl']" @change="group" @cancel="cancel" @save="save"/>
        <my-button v-if="groupInfo['iconUrl']" :state="state" @change="powerSwitch"></my-button>
      </div>
    </div>
    <div class="container">
      <div class="group-device"  v-for="(d,i) in extDevices" :key="`curtain_d_${i}`" v-show="d.devicetype.key==='curtain'">
          <curtain :device="d" ></curtain>
          <div class="group-edit" v-if="isCover"></div>
          <div class="group-checkbox" v-if="isCover" :class="{checked: d.checked, unchecked: !d.checked}" @click="choose(d, i)"></div>
      </div>
      <round class="empty"></round>
      <round class="empty"></round>
      <round class="empty"></round>
    </div>
  </div>
</template>

<script>
import Curtain from '@/components/Curtain'
import Round from '@/components/Round'
import MyButton from '@/components/Button'
import DtitButton from '@/components/DtitButton'
import { mapState, mapActions } from 'vuex'
import { Message } from 'element-ui'
import api from '@/model/device'

export default {
  name: 'DeviceCurtain',
  data () {
    return {
      groupInfo: {
        text: '添加群控',
        type: 'curtain',
        iconUrl: require('@/assets/images/device/aircon/wdz.png'),
        state: false,
        isCancel: false,
        isCovers: false
      },
      name: '',
      index: '',
      desc: '',
      isCover: false
    }
  },
  provide () {
    return {
      all: this
    }
  },
  computed: {
    ...mapState(['extDevices', 'groups']),
    state () {
      return this.extDevices.filter(e => e.devicetype.key === 'curtain').every(l => l.state.state === 1)
    }
  },
  components: {
    MyButton,
    Curtain,
    Round,
    DtitButton
  },
  methods: {
    ...mapActions(['updateGroups']),
    async powerSwitch () {
      try {
        await api.batchControl(['curtain'], this.state ? 'close' : 'open')
        // this.state = !this.state
      } catch (e) {
        Message.error(e.message)
      }
    },
    // 群组功能
    group () {
      if (!this.groupInfo['state']) {
        this.isCover = true
        this.groupInfo = {
          text: '保存',
          type: 'curtain',
          iconUrl: '',
          state: false,
          isCancel: true,
          isCovers: false
        }
      }
      // 保存选中的设备
      if (this.groupInfo['state']) {

      }
    },
    // 取消
    cancel () {
      this.isCover = false
      this.groupInfo = {
        text: '添加群控',
        type: 'curtain',
        iconUrl: require('@/assets/images/device/aircon/wdz.png'),
        state: false,
        isCancel: false,
        isCovers: false
      }
      this.extDevices.forEach((item, index) => {
        item.checked = false
        this.$set(this.extDevices, index, item)
      })
      this.name = ''
      this.desc = ''
      this.index = ''
    },
    // 选中分组设备
    choose (item, index) {
      item.checked = !item.checked
      this.$set(this.extDevices, index, item)
      // 检查是否又被选中的设备
      const isChecked = this.extDevices.some(item => item.checked)
      this.groupInfo['state'] = isChecked
    },
    // 保存组
    async save (data) {
      let listId = this.extDevices.filter(item => item.checked).map(item => item.id)
      // 如果是修改
      if (this.groupInfo.isCovers) {
        this.groups[this.index]['name'] = data.name
        this.groups[this.index]['remark'] = data.desc
        let result = await this.updateGroups(this.groups)
        if (result && result.code === 1) {
          Message.success('修改成功！')
        } else {
          Message.warning('修改失败！')
        }
      } else {
        let result = await this.updateGroups({ name: data.name, remark: data.desc, key: 'curtain', listId })
        if (result && result.code === 1) {
          Message.success('添加成功！')
        } else {
          Message.warning('添加失败！')
        }
      }
    }
  },
  activated () {
    // 处理修改组控
    if (this.$route.params && this.$route.params['include']) {
      this.name = this.$route.params['name']
      this.index = this.$route.params['index']
      this.desc = this.$route.params['desc']
      this.isCover = true
      this.groupInfo = {
        text: '保存',
        type: 'curtain',
        iconUrl: '',
        state: true,
        isCancel: true,
        isCovers: true
      }
      // 判断选中
      this.extDevices.forEach((item, index) => {
        if (this.$route.params['include'].includes(item.id)) {
          item.checked = true
          this.$set(this.extDevices, index, item)
        }
      })
    } else {
      this.cancel()
    }
  },
  mounted () {
    this.cancel()
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/base";

.light {
  display: flex;
  flex-direction: column;
  flex: 1;
  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    > .title {
      font-size: 17px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
    }
    > .fast-btn {
      display: flex;
      align-items: center;
    }
  }
  > .container {
    overflow-y: auto;
    margin-top: 5px;
    flex: 1;
    height: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      margin-top: 20px;
    }
    > .group-device {
      position: relative;
      box-sizing: border-box;
      height: 260px;
      min-width: 230px;
      max-width: 24%;
      .group-edit {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.2;
      }
      .group-checkbox {
        position: absolute;
        bottom: 24px;
        right: 24px;
        width: 30px;
        height: 30px;
        z-index: 1;
      }
      .unchecked {
          background: url('../../assets/images/group/unchecked.png') no-repeat center;
          background-size:cover;
      }
      .checked {
          background: url('../../assets/images/group/checked.png') no-repeat center;
          background-size:cover;
      }
    }
  }
}
</style>
